import { ServiceUrlsService } from '../../common-service/service-urls/service-urls.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class VerifyEmailService {

  constructor(private httpClient: HttpClient,
              private serviceUrls: ServiceUrlsService) { }

  verifyEmail(verifyEmailObject): Observable<any> {
      console.log(verifyEmailObject);
      return this.httpClient.post(this.serviceUrls.verifyEmailServiceUrl , verifyEmailObject);
  }

}



// WEBPACK FOOTER //
// ./src/app/verify-email/service/verify-email.service.ts